/**
 * CSV helper to create csv files
 * @param data this should be a matrix of the table to be printed. Components should make sure the rows only contain
 * data that is printed in csv and have been formatted
 * @param headers an array of header text for the csv. The data rows should follow in the same order as the headers
 * @param fileName a readable string for the name of the csv
 */
export function createCsvFile(
  data: Array<Array<string>>,
  headers: Array<string>,
  fileName: string
): void {
  let csvData = headers.join(",") + "\r\n";

  data.forEach(row => {
    const cleanedRow = row.map(item => cleanupCommas(item));
    csvData += cleanedRow.join(",") + "\r\n";
  });

  saveAsCsv(csvData, fileName);
}

function cleanupCommas(str: string): string {
  return str.replace(/,/gi, "_");
}

export function saveAsCsv(data: string, fileName: string) {
  const blob: Blob = new Blob([data], { type: "text/csv;charset=utf8;" });
  // create link to download
  const tempLink = document.createElement("a");
  tempLink.download = `${fileName}.csv`;
  const url = window.URL.createObjectURL(blob);
  tempLink.href = url;
  // hide link from display
  tempLink.style.display = "none";
  document.body.appendChild(tempLink);
  // automatically click on link and then remove
  tempLink.click();
  document.body.removeChild(tempLink);
}
